import React from "react";
import { Link, useParams } from "react-router";
import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";
import { LANG } from "~/utils/constant";
import { homeRouteString } from "~/utils/helper-funcations";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "../ui/breadcrumb";

interface BreadCrubComponentProps {
  breadCrub: { path: string; title: string }[];
  title?: string | null;
  textColor?: string;
  isLastSeparator?: boolean;
}

const BreadCrubComponent = ({ breadCrub, title, textColor, isLastSeparator = true }: BreadCrubComponentProps) => {
  // const navigate = useNavigate();
  const { lang } = useParams();
  const { medium } = useFontStyle();

  // Check if home route exists in breadCrub, if not add it at the beginning
  const homeRoute = homeRouteString(lang || LANG.english);
  const updatedBreadCrub =
    breadCrub.length > 0 && breadCrub[0]?.path === "/" ? breadCrub : [{ path: homeRoute.path, title: homeRoute.home }, ...breadCrub];

  const isValidPath = (path: string) => {
    return path.startsWith("/") ? `/${lang}${path}` : `/${lang}/${path}`;
  };

  // Calculate max width for each breadcrumb item based on total count
  const totalItems = updatedBreadCrub.length + (title ? 1 : 0);
  const maxItemWidth = totalItems > 3 ? "max-w-[150px]" : totalItems > 2 ? "max-w-[200px]" : "max-w-[250px]";

  return (
    <Breadcrumb>
      <BreadcrumbList
        className={cn("flex flex-nowrap gap-1 justify-start items-center body_text_s capitalize max-md:hidden overflow-hidden", medium)}
      >
        {updatedBreadCrub.map((item, index) => {
          const navigate_to = isValidPath(item.path);
          const isLast = index === updatedBreadCrub.length - 1;
          return (
            <React.Fragment key={index}>
              <Link
                // onClick={() => navigate(navigate_to)}
                to={navigate_to}
                className={cn(
                  "text-textColor opacity-[70%] overflow-hidden line-clamp-1 text-ellipsis whitespace-nowrap flex-shrink-0 capitalize hover:opacity-100 transition-opacity cursor-pointer",
                  maxItemWidth,
                  textColor,
                )}
              >
                {item.title}
              </Link>
              {(!isLast || (isLast && isLastSeparator)) && (
                <BreadcrumbSeparator className={cn("text-textColor opacity-[70%] flex-shrink-0", textColor)} />
              )}
            </React.Fragment>
          );
        })}
        {title && (
          <BreadcrumbPage
            title={title}
            className={cn(
              "body_text_s text-primaryColor capitalize overflow-hidden line-clamp-1 text-ellipsis whitespace-nowrap flex-shrink-0",
              maxItemWidth,
              medium,
              textColor,
            )}
          >
            {title}
          </BreadcrumbPage>
        )}
      </BreadcrumbList>

      {/* mobile view */}
      <BreadcrumbList
        className={cn(
          "flex-nowrap gap-1 justify-start items-center body_text_s capitalize text-textColor opacity-[70%] max-md:flex hidden overflow-hidden",
          medium,
        )}
      >
        {updatedBreadCrub.length > 0 && (
          <BreadcrumbItem className="flex-shrink-0">
            {(isLastSeparator ? updatedBreadCrub : updatedBreadCrub).map((crumb, idx) => {
              const isLast = isLastSeparator ? true : idx === updatedBreadCrub.length - 1;
              const showSeparator = !isLast || (isLast && isLastSeparator);

              return (
                <React.Fragment key={idx}>
                  <Link
                    // onClick={() => navigate(isValidPath(crumb.path))}
                    to={isValidPath(crumb.path)}
                    className="overflow-hidden line-clamp-1 text-ellipsis whitespace-nowrap max-w-[120px] capitalize body_text_s hover:opacity-100 transition-opacity opacity-[70%] cursor-pointer"
                  >
                    {crumb.title}
                  </Link>
                  {showSeparator && <BreadcrumbSeparator className="flex-shrink-0" />}
                </React.Fragment>
              );
            })}
          </BreadcrumbItem>
        )}

        {/* {updatedBreadCrub.length > 1 && isLastSeparator && (
          <BreadcrumbItem className="flex-shrink-0">
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-1">
                <BreadcrumbEllipsis className="h-4 w-4" />
                <span className="sr-only">Toggle menu</span>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start">
                {updatedBreadCrub.slice(1).map((item, index) => {
                  const navigate_to = isValidPath(item.path);
                  return (
                    <DropdownMenuItem key={index}>
                      <Link to={navigate_to} className="overflow-hidden line-clamp-1 max-w-[200px] capitalize body_text_s cursor-pointer">
                        {item.title}
                      </Link>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
              <BreadcrumbSeparator className="flex-shrink-0" />
            </DropdownMenu>
          </BreadcrumbItem>
        )} */}

        {title && (
          <BreadcrumbPage
            className={cn(
              "body_text_s text-primaryColor capitalize overflow-hidden truncate whitespace-nowrap w-[100px] md:w-[150px] 2xl:w-[200px] flex-shrink-0",
              medium,
            )}
          >
            {title}
          </BreadcrumbPage>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadCrubComponent;
